import PropTypes from "prop-types";
import { IconArrowLeft } from '@tabler/icons'

export const SectionHeader = (props) => {
  const { label, description, actions, backButton, backButtonAction, search, hasSearch, containerClass } = props;
  return (
    <div className={`w-full ${containerClass}`}>
      <div className="mr-auto mb-[32px]">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
            {backButton && <IconArrowLeft size="24px" className="cursor-pointer mr-1 text-primary" onClick={backButtonAction} data-attribute='arrow-go-back'/>}
            <div>
              {label}
              {description && <p className="text-sm text-gray-800">{description}</p>}
            </div>
          </div>
          {actions?.length > 0 && (
            <div className="flex ml-auto">
              {actions.map((action, index) => (
                <div className={`inline-block${index ? " ml-1" : ""}`} key={index}>
                  {action}
                </div>
              ))}
            </div>
          )}
        </div>
        {hasSearch && (
          <div className="w-full">
            {search}
          </div>
        )}
      </div>
    </div>
  );
};

SectionHeader.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.node),
  label: PropTypes.node,
  description: PropTypes.string,
  backButton: PropTypes.bool,
  backButtonAction: PropTypes.func,
  containerClass: PropTypes.string,
  hasSearch: PropTypes.bool,
  search: PropTypes.node,
};

SectionHeader.defaultProps = {
  actions: [],
  containerClass: "",
  label: <h3 className="text-xl font-light font-rubik">TEST HEADING</h3>,
  backButton: false,
  hasSearch: false,
};